<template>
  <div class="test">
    <Tabs :value="state" @on-click="handleChangeTab">
      <TabPane label="全部" name="all">
        <TestTab v-if="state == 'all'" :state="state" />
      </TabPane>
      <TabPane label="未通过" name="0">
        <TestTab v-if="state == '0'" :state="state" />
      </TabPane>
      <TabPane label="已通过" name="1">
        <TestTab v-if="state == '1'" :state="state" />
      </TabPane>
      <div class="record" slot="extra" @click="handleToRecord">
        <span>考试记录</span>
      </div>
    </Tabs>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
import TestTab from "@/components/userCenter/TestTab.vue";
export default {
  name: "test",
  components: { TestTab },
  data() {
    return {
      state: "all",
    };
  },

  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleToRecord() {
      this.$router.push({
        path: "/attendanceProcess/TestRecord",
      });
    },
    handleChangeTab(name) {
      this.state = name;
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  margin-bottom: 20px;
  width: 962px;
  float: right;
  background: #fff;
  .record {
    line-height: 59px;
    padding-right: 20px;
    span {
      cursor: pointer;
      font-size: 14px;
      color: rgba(34, 34, 34, 1);
    }
  }
}
</style>
